import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

type ReadStoryOperation = 'GetStoryV3'

export type ReadStoryV3ResponseData = OpalApiResponseDocument<
  ReadStoryOperation,
  200
>

export type ReadStoryV3RequestParams = OpalApiRequestParams<ReadStoryOperation>

export async function readSingle(
  params: ReadStoryV3RequestParams
): Promise<ReadStoryV3ResponseData> {
  const url = new URL(
    `/stories/v3/${params.path.story_id}`,
    window.location.origin
  )

  url.search = queryString({
    'expose[meta][access]': String(!!params.query?.expose?.meta?.access),
  })

  return HttpClient()
    .get<ReadStoryV3ResponseData>(url.toString())
    .then((res) => res.data)
}
